import { BankAccountCard } from "interfaces";
import { makeAutoObservable, runInAction } from "mobx";
import { fetchGetBankAccountDetails, NormalizedError } from "services";
import { statusFetching } from "services/authClient/constants/types";

export class BankAccountsDetailStore {
  bankAccountsDetails: Record<string, BankAccountCard> = {};
  loading = false;
  error: string | null = null;

  public fetchStatus: statusFetching = "init";
  public fetchError?: NormalizedError;

  constructor() {
    makeAutoObservable(this);
  }

  get isPending() {
    return this.fetchStatus === "fetching";
  }

  async fetchBankAccountDetails(companyId: string, accountId: string) {
    runInAction(() => {
      this.fetchStatus = "fetching";
      this.fetchError = undefined;
    });

    try {
      const response = await fetchGetBankAccountDetails({
        companyId,
        id: accountId,
      });
      if (response) {
        runInAction(() => {
          this.setBankAccountDetails(accountId, response);
          this.fetchStatus = "success";
        });
        return response;
      }
    } catch (error: any) {
      runInAction(() => {
        this.fetchStatus = "error";
        this.fetchError = error;
      });
    }
  }

  clearError() {
    runInAction(() => {
      this.error = null;
    });
  }

  setBankAccountDetails(accountId: string, details: BankAccountCard) {
    runInAction(() => {
      this.bankAccountsDetails = {
        ...this.bankAccountsDetails,
        [accountId]: details,
      };
    });
  }

  getBankAccountDetails(accountId: string): BankAccountCard | undefined {
    return this.bankAccountsDetails[accountId];
  }
}
